<template>
  <div :class="[classes.footer, 'footer', layoutClass]">
    <BrandText
      tag="span"
      styleGroup="Terms"
      :overideText="overideTerms"
      :get="brand => brand.adTemplate.footer"
      :class="[{ [classes.emptyText]: footerEmpty }]"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import BrandText from "./BrandText.vue";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { useGetOffer, useShouldDisplayOffer } from "../hooks/useDisplayOffer";
import { injectLayout, STRAPLINE } from "../hooks/useLayout";

const useStyles = createUseStyles({
  footer: {
    lineHeight: 1,
    paddingTop: "5px",
    fontSize: "8px",
    textAlign: "center",
    [`&.${STRAPLINE}`]: {
      paddingTop: "2px"
    }
  },
  emptyText: {
    display: "block",
    width: "100%",
    minHeight: "12px"
  }
});

export default defineComponent({
  name: "Footer",
  components: {
    BrandText
  },
  setup() {
    const { layout } = injectLayout();
    const classesRef = useStyles();
    const { footerBranding } = injectBrand();
    const offer = useGetOffer();
    const showOffer = useShouldDisplayOffer();

    const footerEmpty = computed(() => !footerBranding.value?.value.length);

    return {
      footerEmpty,
      overideTerms: computed(() => showOffer.value && offer.value?.terms),
      classes: classesRef.value,
      layoutClass: layout
    };
  }
});
</script>
